<template>
  <div class="selected-item cursor-pointer" @click="editCheck">
    <icon icon="grip-vertical" id="handle"/>
    <span class="tag is-sort-number is-cool-blue-dark is-medium is-rounded mr-1">{{ index + 1 }}</span>
    <div :class="{'has-10-columns' : customWeighting}" class="grid has-8-columns gap-1 flex-grow align-center">
      <div class="is-5-columns is-flex flex-column">
        <span class="has-text-weight-bold">{{ check.name }}</span>
        <span class="has-text-cool-blue-text">{{ check.task | truncate(100) }}</span>
      </div>
      <div class="is-flex align-center justify-end">
        <span class="tag is-rounded is-warning has-text-weight-bold has-tooltip-top" data-tooltip="If this check fails, the entire inspection fails immediately." v-if="check.instant_fail">Instant Fail</span>
      </div>
      <div class="is-2-columns tags has-addons is-flex align-items-center justify-end is-one-line ml-4" @click.stop  v-if="customWeighting">
        <span v-if="check.can_skip" class="tag is-size-6-5 has-tooltip-top has-text-info is-cool-blue is-rounded pr-0" data-tooltip="This weight will count as a failure if the answer is marked “N/A” because the check is skippable."><icon icon="exclamation"/></span>
        <span class="tag is-size-6-5 is-cool-blue is-rounded">{{ Naming.Check }} Weight</span>
        <input
            :class="textClass"
            style="min-width: 70px; font-weight: 500"
            class="input tag is-size-6-5 has-background-white"
            type="number"
            v-model="localPercentageWeight"
            @input="setCheckWeight"
            :min="0"
            :max="100"
            :step="5"/>
      </div>
      <div class="tags has-addons is-one-line has-tooltip-top tag-rule-width" data-tooltip="Image Rule">
        <span class="tag is-size-6-5 is-icon is-rounded is-cool-blue-dark has-text-cool-blue-text-dark has-text-weight-medium"><icon icon="camera"/></span>
        <span class="tag is-size-6-5 is-rounded flex-grow is-cool-blue">{{ check.image_rule | startCase }}</span>
      </div>
      <div class="tags has-addons is-one-line tooltip has-tooltip-top tag-rule-width" data-tooltip="Comment Rule">
        <span class="tag is-size-6-5 is-icon is-rounded is-cool-blue-dark has-text-cool-blue-text-dark has-text-weight-medium"><icon icon="comment"/></span>
        <span class="tag is-size-6-5 is-rounded flex-grow is-cool-blue">{{ check.comment_rule | startCase }}</span>
      </div>
    </div>
    <icon icon="edit" class="hover-success has-text-cool-blue-text is-size-6 ml-1"  @click.stop="editCheck"/>
    <a v-show="canDelete" :disabled="isLocked" class="delete is-medium ml-1" @click.stop="$emit('onRemoveCheck', index)"/>
  </div>
</template>

<script>
import startCase from 'lodash/startCase'
import { editCheck } from '@/modals'

export default {

  filters: {
    startCase
  },

  data: () => ({
    localPercentageWeight: null,
    isEditing: false
  }),

  created() {
    this.localPercentageWeight = this.check.percentage_weight
  },

  computed:{
    textClass(){
      return this.localPercentageWeight === 0 ? 'has-text-danger' : ''
    }
  },

  props: {
    check: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isLocked: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: true
    },
    customWeighting: {
      type: Boolean,
      default: false
    },
  },

  methods: {
    async editCheck() {
      if (this.isEditing) return
      this.isEditing = true
      this.$store.commit('check/setCheck', this.check)
      const updatedCheck = await editCheck();
      this.isEditing = false
      if (updatedCheck === 'deleted') {
        return this.$emit('deleteCheck', this.check.id);
      }
      if(updatedCheck) {
        updatedCheck.percentage_weight = this.check.percentage_weight
        this.$emit('onCheckUpdated', Boolean(updatedCheck), updatedCheck)
      }

    },
    setCheckWeight() {
      const payload = {
        checkId: this.check.id,
        value: this.localPercentageWeight
      }
      this.$emit('weights', payload)
    }
  },
  watch: {
    check: {
      handler(newVal) {
        this.localPercentageWeight = newVal.percentage_weight;
      },
      deep: true,
    },
  },

}
</script>